import { render, staticRenderFns } from "./BidIdParsingSettings.vue?vue&type=template&id=902cd4c8"
import script from "./BidIdParsingSettings.vue?vue&type=script&lang=js"
export * from "./BidIdParsingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports